import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Message, Button, Icon } from 'semantic-ui-react';
import { DyzioPrimaryButton } from 'dyzio-shared-components/lib/components/dyzio-buttons';
import _ from 'lodash';
import { loadingDiscussions, reloadDiscussions } from './actions';
import { checkUserIsTeamMember } from '../../utils/role-service';
import { PARTNER_AGENCY, CLIENT, COLLABORATIONS, GROUP_CHATS } from '../../utils/static-configuration';
import DiscussionCard from '../../containers/discussion-card';
import CollaborationCard from '../../containers/collaboration-card';
import hasRESTClient from '../../hocs/has-rest-client';
import hasUserInfo from '../../hocs/has-user-info';


import ThemeSelector from '../../themes/theme-selector';
const currentTheme = ThemeSelector.theme();

const CORQ_DOMAIN = 'data.corq.studio';

class DiscussionList extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  componentDidMount() {
    if (this.props.reloadDiscussions) {
      setTimeout(() => {
        this.props.onReloadDiscussions({
          campaignId: this.props.campaignId });
      }, 4000);
    } else {
      this.props.onLoadingDiscussions(this.props.campaignId);
    }
  }

  getInfluencerFromOrganisations = (organisations, discussionName) => {
    if (organisations) {
      const isDiscussionOrganisation = organisation => organisation.influencer !== null;
      const discussionOrganisation = _.find(organisations.toJS(), isDiscussionOrganisation);
      const influencer = discussionOrganisation && discussionOrganisation.influencer;
      return influencer;
    }
    return null;
  }

  refreshPage = () => {
    this.props.reload();
  }

  render() {
    const {
      myUserRole,
      discussions,
      campaign,
      error,
      loading,
      reloadDiscussions,
      showCollaborationType,
      campaignId,
      filterDiscussionListByTerm,
      currency,
      organisation,
      trackedAssetsCount,
      restClient,
      userInfo,
    } = this.props;

    const { isUserSuperAdmin } = userInfo;

    const clientDiscussionId = campaign.get('clientDiscussion');
    const clientDiscussion = clientDiscussionId ? discussions.get(clientDiscussionId) : null;
    const teamDiscussionId = campaign.get('teamDiscussion');
    const teamDiscussion = teamDiscussionId ? discussions.get(teamDiscussionId) : null;
    const partnerAgencyDiscussionId = campaign.get('partnerAgencyDiscussion');
    const partnerAgencyDiscussion = partnerAgencyDiscussionId ? discussions.get(partnerAgencyDiscussionId) : null;
    const campaignOwner = campaign.get('createdBy');
    const isUserTeamMember = isUserSuperAdmin || checkUserIsTeamMember(myUserRole);

    const sortedDiscussions = discussions.sortBy(d => _.toLower(d.get('name')));
    const isLoading = loading; // taken out to test || reloadDiscussions;

    const { hostname } = window.location;

    const isCORQ = (hostname === CORQ_DOMAIN);

    return (
      <div>
        { isLoading &&
          <div className="discussion-preloader">
            <img src="/icons/dyzio-icon.svg" alt="Loading..." />
          </div>
        }
        { !isLoading && error &&
          <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
            <div className="hero left">
              <Message color="red">
                <p>There was a problem loading the collaborations: {error}. Please check you are connected to the internet and try again.</p>
              </Message>
            </div>
          </div>
        }
        { showCollaborationType === GROUP_CHATS && !isLoading && !error && (teamDiscussion || clientDiscussion) &&
          <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
            <h2>Group Chats</h2>
          </div>
        }
        { showCollaborationType === GROUP_CHATS && !isLoading && !error && teamDiscussion && isUserTeamMember &&
          <DiscussionCard
            discussion={teamDiscussion}
            size="medium"
            isCreatorDiscussion={false}
          />
        }
        { showCollaborationType === GROUP_CHATS && !isLoading && !error && clientDiscussion && (isUserTeamMember || myUserRole === CLIENT) &&
          <DiscussionCard
            discussion={clientDiscussion}
            size="medium"
            isCreatorDiscussion={false}
          />
        }
        { showCollaborationType === GROUP_CHATS && !isLoading && !error && partnerAgencyDiscussion && (myUserRole === PARTNER_AGENCY || isUserTeamMember) &&
          <DiscussionCard
            discussion={partnerAgencyDiscussion}
            size="medium"
            isCreatorDiscussion={false}
          />
        }
        { showCollaborationType === COLLABORATIONS && !isLoading && (sortedDiscussions.size === 0) && (!isUserTeamMember) &&
          <div style={{ width: 1000, margin: '50px auto' }}>
            <Message
              icon="ban"
              error
              header="Sorry... You do not have access to this campaign"
              content={`Ask the campaign owner, ${campaignOwner}, to invite you.`}
            />
          </div>
        }
        { showCollaborationType === COLLABORATIONS
          && !isLoading
          && sortedDiscussions.size > 0
          // eslint-disable-next-line lodash/prefer-lodash-method
          && sortedDiscussions.map(discussion => {
            const id = discussion.get('id');
            const discussionName = discussion.get('name');
            // Don't show the team or client discussions
            if (id === clientDiscussionId || id === teamDiscussionId || id === partnerAgencyDiscussionId) {
              return null;
            }

            const primarySocialHandle = discussion.get('influencerName');
            const hasSearchTerm = filterDiscussionListByTerm && _.size(filterDiscussionListByTerm) > 0;

            const term = _.lowerCase(_.trim(filterDiscussionListByTerm));

            const nameMatchValue = _.lowerCase(_.trim(discussionName));
            const handleMatchValue = _.lowerCase(_.trim(primarySocialHandle));

            const matchesByName = _.includes(nameMatchValue, term);
            const matchesByPrimaryHandle = _.includes(handleMatchValue, term);
            if (hasSearchTerm && !matchesByName && !matchesByPrimaryHandle) {
              return null;
            }

            const discussionOrganisations = discussion.get('organisations');
            const influencer = this.getInfluencerFromOrganisations(discussionOrganisations, discussionName);

            return (
              <div>
                <div style={{ padding: 15, marginBottom: 15, height: 50 }}>
                  <DyzioPrimaryButton
                    onClick={() => window.open(`${currentTheme.shareSite}/collab/${id}/campaign`)}
                    label={'open collaboration report...'}
                    hasIcon
                    icon={<Icon name="file alternate outline" />}
                    floated="right"
                  />
                </div>
                { influencer
                  ? <CollaborationCard
                    organisation={organisation}
                    trackedAssetsCount={trackedAssetsCount}
                    discussion={discussion}
                    influencer={influencer}
                    campaign={campaign}
                    currency={currency}
                    restClient={restClient}
                    refreshPageHandler={this.refreshPage}
                  />
                  : <DiscussionCard
                    discussion={discussion}
                    influencer={influencer}
                    size="large"
                    isCreatorDiscussion
                  />
                }
              </div>
            );
          })}
        { (campaign.get('campaignType') !== 'ACR' || sortedDiscussions.size === 0) &&
        showCollaborationType === COLLABORATIONS &&
        !isLoading &&
        !error &&
         isUserTeamMember &&
         !isCORQ &&
         <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
           <div
             className="box centered small clickable"
             onClick={() => this.context.router.push(`/campaign/${campaignId}/invite`)}
           >
             <div className="box-content-one">
               <div className="box-content-two">
                 <div className="box-content-three">
                   <button className="large rose wide">
                     <p>Add an Influencer or Team Member</p>
                   </button>
                 </div>
               </div>
             </div>
           </div>
         </div>
        }
      </div>
    );
  }
}

DiscussionList.propTypes = {
  routeParams: React.PropTypes.object,
};

const mapStateToProps = state => ({
  discussions: state.discussionList.get('discussions'),
  myUserRole: state.campaign.get('myUserRole'),
  error: state.discussionList.get('error'),
  loading: state.discussionList.get('loading'),
  reloadDiscussions: state.discussionList.get('reloadDiscussions'),
  campaign: state.campaign.get('campaign'),
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onLoadingDiscussions: campaignId => dispatch(loadingDiscussions(campaignId)),
    onReloadDiscussions: data => dispatch(reloadDiscussions(data)),
  };
}

export default compose(
  hasUserInfo,
  hasRESTClient,
  connect(mapStateToProps, mapDispatchToProps),
)(DiscussionList);



/** WEBPACK FOOTER **
 ** ./src/containers/discussion-list/index.js
 **/